import { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import {
  CONIFRM_NMI_VERIFICATION_TRANSACTIONS,
  SEND_NMI_VERIFICATION_TRANSACTIONS,
} from "../graphql/mutations/nmi";
const {
  CardHeader,
  CardBody,
  CardFooter,
  Card,
  Col,
  Row,
  Button,
  FormGroup,
  Input,
} = require("reactstrap");

function NMIVerify() {
  const [step, setStep] = useState(1);
  const [fielderrors, setFieldError] = useState([]);
  const [amount1, setAmount1] = useState(0);
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const [sendNMIVerificationTransactions] = useMutation(
    SEND_NMI_VERIFICATION_TRANSACTIONS,
  );
  const [verifyTempNMITransactions] = useMutation(
    CONIFRM_NMI_VERIFICATION_TRANSACTIONS,
  );

  const CheckError = (e) => {
    if (fielderrors.length > 0) {
      const q = fielderrors.find((a) => a.field === e);
      if (q) return q.error;
      else return false;
    } else return false;
  };

  const handleChange = (e, theFunc) => {
    const newValue = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(newValue)) {
      theFunc(newValue);
    }
  };

  const SendIFrameMessage = (data, action) => {
    window.parent.postMessage(
      { type: "FROM_IFRAME", payload: { data: data, action: action } },
      process.env.REACT_APP_WOWCLOUD_PARENT + "/verify-card",
    ); //Parent
  };

  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_WOWCLOUD_PARENT) return; //Parent

      const { type, payload } = event.data;

      if (type === "FROM_PARENT") {
        if (payload.action === "SendPhone") {
          setPhone(payload.data);
          setLoading(true);
          sendNMIVerificationTransactions({
            variables: { phone: payload.data },
          })
            .then((tres) => {
              if (tres.data.sendNMIVerificationTransactions.status) setStep(2);
              else {
                SendIFrameMessage(
                  tres.data.sendNMIVerificationTransactions.error,
                  "TransactionError",
                );
              }
            })
            .catch((err) => {
              console.log("ERROR2", err);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      }
    };

    window.addEventListener("message", handleIframeMessage);

    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, []);

  const SendCharges = () => {
    SendIFrameMessage(null, "SendPhone");
  };

  const VerifyCharges = () => {
    setLoading(true);
    verifyTempNMITransactions({
      variables: { phone: phone, amount1: parseFloat(amount1) },
    })
      .then((tres) => {
        if (tres.data.verifyTempNMITransactions.status)
          SendIFrameMessage(
            tres.data.verifyTempNMITransactions.data,
            "VerificationSuccess",
          );
        else {
          if (
            tres.data.verifyTempNMITransactions.error ===
            "Verification Attempts Exceeded"
          ) {
            SendIFrameMessage(
              tres.data.verifyTempNMITransactions.error,
              "TransactionError",
            );
          } else {
            SendIFrameMessage(
              tres.data.verifyTempNMITransactions.error,
              "VerificationError",
            );
          }
        }
      })
      .catch((err) => {
        console.log("ERROR2", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="mwContainer">
      {loading && (
        <Row>
          <Col md="12">
            <h1>Processing ...</h1>
          </Col>
        </Row>
      )}
      {step === 1 && !loading && (
        <Row>
          <Col md="12">
            <Button
              className="btn-fill mwbtn"
              color="info"
              type="button"
              style={{ width: "100%" }}
              onClick={(e) => SendCharges()}
            >
              I consent to this verification. Continue.
            </Button>
          </Col>
        </Row>
      )}

      {step === 2 && !loading && (
        <>
          <Row>
            <Col md="12">
              <FormGroup>
                <label className="subTitle">*Amount 1 </label>
                <Input
                  type="text"
                  name="amount1"
                  value={amount1}
                  onChange={(e) => handleChange(e, setAmount1)}
                  autoComplete="off"
                  maxLength={4}
                  className={CheckError("amount1") ? "error" : ""}
                />
                <span className="errorMessage">
                  {CheckError("amount1") ? CheckError("amount1") : ""}
                </span>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Button
                className="btn-fill mwbtn"
                color="info"
                type="button"
                style={{ width: "100%" }}
                onClick={(e) => VerifyCharges()}
              >
                Verify Charges
              </Button>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default NMIVerify;
